export const STREAK_WINDOW_MS = 3000;
export const STREAK_CLEAR_COUNT = 4;

/** Four successful clears in a rolling window; each clear earns one streak only. */
export class ClearStreak {
  private clears: number[] = [];

  record(now: number): boolean {
    this.clears = this.clears.filter(time => now - time <= STREAK_WINDOW_MS);
    this.clears.push(now);
    if (this.clears.length < STREAK_CLEAR_COUNT) return false;
    this.reset();
    return true;
  }

  reset(): void { this.clears = []; }
}
